import Color from 'color';

import { styled } from '@mui/styles';

import CbButtonBase from '../../components/Buttons/CbButton';

import { withShowable } from '../_global/lib/withShowable';

/** The rail's pivot, measured in from the page column's outer edge. */
const TAB_RAIL_INSET = '1.5rem';

/**
 * The rail's thickness once rotated: a tab button's height, its 0.5rem
 * vertical padding either side of a 0.875rem label.
 */
const TAB_RAIL_THICKNESS = '2.5rem';

/**
 * How far the rail reaches in from the page column's outer edge. Rotated about
 * its right-centre, it straddles the pivot, so half its thickness lies inside.
 * A view that renders the rail pads its right side by this, less the page
 * gutter, so nothing right-aligned sits under it.
 */
export const TAB_RAIL_REACH = `calc(${TAB_RAIL_INSET} + ${TAB_RAIL_THICKNESS} / 2)`;

export const TabButtonContainer = withShowable(
  styled('div')({
    position: 'fixed',
    // Keep the 1.5rem inset: the rail is rotated -90deg about its right edge,
    // so its painted box sits further right than `right` implies. At 0 the
    // labels hung 14px off a 1440px viewport and were clipped.
    right: `calc(var(--ask-moo-sidebar-width, 0px) + ${TAB_RAIL_INSET})`,
    top: '30%', // Moved up from 50% to 30% for better positioning
    zIndex: 500,
    transform: 'translateY(-50%) rotate(-90deg)',
    transformOrigin: 'center right',

    '& > *:not(:last-child)': {
      marginRight: '.5rem', // Increased from .2rem to .5rem (4px)
    },
  })
);

// @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
export const TabButton = styled(CbButtonBase, {
  shouldForwardProp: (prop: any) =>
    !(prop === 'backgroundColor' || prop === 'color'),
})(({ color, backgroundColor }) => ({
  // Rotated -90deg, so the vertical padding is what the rail costs the page
  // horizontally -- but it also has to leave room for the label.
  padding: '.5rem 1.5rem',
  backgroundColor,
  borderRadius: '5px 5px 0 0',
}));
